import React from 'react';
import '../../styles/layout.css';

const PageContainer = ({ children, className = '' }) => (
  <div className={`page-container ${className}`.trim()}>
    {children}
  </div>
);

export default PageContainer;
